import { useState } from 'react';
import controllerConfigs from '../configs';
import { useTranslation } from 'react-i18next';
import FormManager from '@app/components/EasyForm';
import AppDispatcher from '@app/events/app-commander';
import DomainModuleFactory from '@core/domain/index.module';

export default function activeAccountProvider(Page) {
  return function (props) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const handleOnSubmit = ev => {
      ev.preventDefault();
      setIsLoading(true);
      if (!formManager.isValid()) {
        setIsLoading(false);
        return;
      }

      const { fiscalId, captchaToken } = formManager.getData();

      ResetPasswordUseCase.execute({ fiscalId, captchaToken })
        .then(() => AppDispatcher.visitPage({ path: '/password-reset-instructions' }))
        .catch(({ code }) => AppDispatcher.showToast({ mode: 'error', message: code }))
        .finally(() => setIsLoading(false));
    };

    return <Page {...props} t={t} isLoading={isLoading} controllers={controllers} handleOnSubmit={handleOnSubmit} />;
  };
}

const ResetPasswordUseCase = DomainModuleFactory.auth().createRequestResetPasswordUseCase();

const defaultState = { fiscalId: '', captchaToken: '' };
const formManager = new FormManager({ formIndex: 'recovery-password-form', defaultState });
const controllers = formManager.initControllers(controllerConfigs);
